import { ErrorOutlineRounded, TravelExploreRounded } from "@mui/icons-material";
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { authManager } from "../data/managers/AuthManager";
import { useAuth } from "../data/providers/AuthProvider";

export default function LoginAdminPage() {
  const [email, setEmail] = useState("");
  const [passport, setPassport] = useState("");
  const [accessCode, setAccessCode] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { user } = useAuth();

  if (user) window.location.href = "/dashboard";

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email || !passport || !accessCode) return;
    setIsSubmitting(true);
    setError("");
    try {
      await authManager.loginWithAccessCode({
        email,
        passport,
        accessCode,
      });
      window.location.href = "/dashboard";
    } catch (err: unknown) {
      const message =
        err instanceof Error ? err.message : "No se pudo iniciar sesión";
      setError(message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background:
          "linear-gradient(135deg, #f2f6ff 0%, #ffffff 60%, #dfe9ff 100%)",
        px: 2,
      }}
    >
      <Card
        sx={{
          maxWidth: 430,
          width: "100%",
          borderRadius: 4,
          background: "#fff",
          boxShadow: "0 10px 40px rgba(0,0,0,0.08)",
        }}
      >
        <CardContent sx={{ p: 4 }}>
          <Stack spacing={1.5} alignItems="center" textAlign="center">
            <Box
              sx={{
                bgcolor: "primary.main",
                width: 56,
                height: 56,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 0 20px rgba(24,59,255,0.3)",
              }}
            >
              <TravelExploreRounded sx={{ color: "#fff", fontSize: 30 }} />
            </Box>
            <Typography
              variant="h5"
              fontWeight={800}
              sx={{
                background:
                  "linear-gradient(90deg, #0E1EFD 0%, #0066FF 50%, #0099FF 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                fontFamily: "Montserrat, sans-serif",
              }}
            >
              Ingreso con código
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Correo, pasaporte y código de acceso.
            </Typography>
          </Stack>

          <form onSubmit={handleSubmit}>
            <Stack spacing={2} sx={{ mt: 3 }}>
              <TextField
                fullWidth
                type="email"
                label="Correo"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                inputProps={{ autoComplete: "email", name: "code_access_email" }}
              />
              <TextField
                fullWidth
                label="Pasaporte"
                value={passport}
                onChange={(e) => setPassport(e.target.value)}
                inputProps={{
                  autoComplete: "username",
                  name: "code_access_passport",
                }}
              />
              <TextField
                fullWidth
                type="password"
                label="Código"
                value={accessCode}
                onChange={(e) => setAccessCode(e.target.value)}
                inputProps={{
                  autoComplete: "current-password",
                  name: "code_access_key",
                }}
              />
            </Stack>

            <Button
              fullWidth
              variant="contained"
              type="submit"
              sx={{
                mt: 3,
                py: 1.3,
                fontWeight: 600,
                borderRadius: 2,
                background: "linear-gradient(90deg, #183BFF 0%, #0061FF 100%)",
                "&:hover": {
                  background: "linear-gradient(90deg, #0E1EFD 0%, #0066FF 100%)",
                },
              }}
              disabled={!email || !passport || !accessCode || isSubmitting}
            >
              {isSubmitting ? <CircularProgress size={22} /> : "Ingresar"}
            </Button>
          </form>

          {error && (
            <Alert
              severity="error"
              sx={{
                mt: 2,
                fontWeight: 600,
                fontSize: 15,
                textAlign: "center",
              }}
              iconMapping={{
                error: <ErrorOutlineRounded sx={{ fontSize: 26 }} />,
              }}
            >
              {error}
            </Alert>
          )}
        </CardContent>
      </Card>
    </Box>
  );
}
